import type { SVGProps } from 'react'

/**
 * The bid mark: a money bag with a dollar sign, supplied as a Figma export.
 * Drawn in the current text colour so it sits on the purple tile, the
 * gradient buttons and plain labels alike. The artwork is 51×61, so it
 * letterboxes inside the square `size` box.
 */
export default function BidIcon({ size = 15, ...props }: SVGProps<SVGSVGElement> & { size?: number }) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 51 61"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
			{...props}
		>
			<path
				d="M34.7 16.3135H16.3C8.5 23.3135 0 36.2135 0 45.6135C0 59.1135 4.3 60.3135 25.5 60.3135C46.7 60.3135 51 59.2135 51 45.7135C51 36.3135 42.5 23.3135 34.7 16.3135ZM29.4 46.5135L29.3 46.6135C28.6 47.2135 27.7 47.7135 26.8 47.9135V50.7135H23.9V47.9135C23.1 47.7135 22.4 47.3135 21.8 46.8135C20.8 46.0135 20.2 44.9135 20.1 43.7135L23 43.3135C23.1 43.8135 23.3 44.2135 23.7 44.5135C24.7 45.4135 26.4 45.4135 27.4 44.5135C28 43.9135 28.3 43.2135 28.2 42.4135C28.1 41.7135 27.8 41.0135 27.2 40.6135C26.5 40.1135 25.8 39.9135 25 39.7135C23.9 39.5135 22.7 39.2135 21.6 38.1135C20.5 37.0135 20 35.7135 20 34.4135C20.1 33.2135 20.6 32.0135 21.6 31.1135H21.7C22.3 30.6135 23 30.2135 23.8 30.0135V27.2135H26.7V30.0135C27.6 30.2135 28.4 30.7135 29.1 31.3135C29.8 31.9135 30.3 32.7135 30.6 33.6135L27.6 34.1135C27.5 33.9135 27.3 33.7135 27.2 33.5135C26.2 32.7135 24.6 32.6135 23.6 33.5135C23.3 33.8135 23 34.2135 23 34.7135C23 35.2135 23.3 35.8135 23.7 36.2135C24.2 36.7135 24.7 36.8135 25.6 37.1135C26.5 37.3135 27.7 37.6135 28.9 38.5135C30.2 39.4135 30.9 40.9135 31 42.5135C31.1 43.8135 30.5 45.4135 29.4 46.5135Z"
				fill="currentColor"
				fillRule="evenodd"
				clipRule="evenodd"
			/>
			<path
				d="M16.5 13.3133H34.4L38.6 3.61327C39.3 1.91327 39.5 -0.186726 36.1 0.0132743C33.3 0.113274 31.3 2.91328 28.4 1.21328C26.4 0.013275 23.8 -0.0867249 22.1 1.21328C20.4 2.51328 17.5 0.213274 14.8 0.0132743C11.5 -0.186726 11.6 1.91327 12.3 3.61327L16.5 13.3133Z"
				fill="currentColor"
			/>
		</svg>
	)
}
